import type { QueryParameters } from './json-api.types'

export function customParametersSerializer(parameters: QueryParameters) {
  return Object.entries(parameters)
    .filter(([, value]) => value != undefined)
    .map(([key, value]) => `${key}=${value}`)
    .join('&')
}
